import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

const RobosHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { name: 'Home', href: '/', isInternal: true },
    { name: 'Resultados', href: '#testimonials', isInternal: false },
    { name: 'Depoimentos', href: '#video-testimonials', isInternal: false },
    { name: 'Vantagens', href: '#value', isInternal: false },
    { name: 'Robôs Prontos', href: '#robots', isInternal: false },
    { name: 'Dúvidas Frequentes', href: '#faq', isInternal: false }
  ];

  const handleNavigation = (item: typeof navItems[0]) => {
    if (item.isInternal) {
      navigate(item.href);
    } else {
      scrollToSection(item.href);
    }
    setIsMenuOpen(false);
  };

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      let headerHeight = 80;
      
      // Para Produtos e Robôs Prontos, usar o mesmo offset do footer (Preços)
      if (href === '#robots') {
        headerHeight = -400; // Vai ainda mais baixo para mostrar os cards na posição ideal
      }
      
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="bg-slate-900/95 backdrop-blur-sm border-b border-slate-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-18 lg:h-20">
          {/* Logo */}
          <div className="flex items-center justify-center md:justify-start flex-1 md:flex-initial">
            <button 
              onClick={handleLogoClick}
              className="w-32 h-32 md:w-36 md:h-36 lg:w-40 lg:h-40 flex items-center justify-center p-2 hover:opacity-80 transition-opacity duration-200"
            >
              <img 
                src="/lovable-uploads/quantmake-logo-principal-robo-trader-automatizado.png" 
                alt="QuantMake.AI - Robô Trader Premium Day Trade Automatizado Copy Trade"
                className="w-full h-full object-contain" 
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-4 md:space-x-6 lg:space-x-8 xl:space-x-10">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavigation(item)}
                className="text-slate-300 hover:text-cyan-400 transition-colors duration-200 text-xs md:text-sm lg:text-base font-medium focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-900 rounded px-2 py-1"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Desktop Button */}
          <div className="hidden md:flex items-center ml-4 md:ml-6 lg:ml-8">
            <a href="https://rebrand.ly/AutoTradingAcademy" target="_blank" rel="noopener noreferrer">
              <Button className="bg-gradient-to-r from-cyan-400 to-green-400 hover:from-cyan-500 hover:to-green-500 text-slate-900 font-semibold focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-900">
                Área do Cliente
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden absolute right-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
              aria-expanded={isMenuOpen}
              className="text-slate-300 focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-900"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-slate-800 rounded-lg mt-2">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavigation(item)}
                  className="block w-full text-left px-3 py-2 text-slate-300 hover:text-cyan-400 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-800 rounded"
                >
                  {item.name}
                </button>
              ))}
              <div className="pt-4">
                <a href="https://rebrand.ly/AutoTradingAcademy" target="_blank" rel="noopener noreferrer" className="block">
                  <Button className="w-full bg-gradient-to-r from-cyan-400 to-green-400 hover:from-cyan-500 hover:to-green-500 text-slate-900 font-semibold focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-800">
                    Área do Cliente
                  </Button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default RobosHeader;